// export default {
//   endPointAddress: '/auth/me',
//   meEndpoint: '/auth/me',
//   loginEndpoint: '/jwt/login',
//   registerEndpoint: '/jwt/register'

// } 

export default {
  // serviceAdress:"http://192.168.2.80/DaxlerServis/",
  // serviceAdress:"http://192.168.1.100/DaxlerApi/",
  serviceAdress:"https://kututasarimi.com/KtApi/",
  // serviceAdress:"http://pixelyazilim.com.tr/DaxlerApi/",
  serviceLogin:"giris",
  unLocked:"Unlocked/",
  locked:"Locked/", 
  storageUserIdKeyName: 'userId',
  storageTokenId: 'tokenId',
  storageTokenKeyName: 'accessToken', 
  tokenType:'Bearer'
}
